// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"62e9db15","963":"6fbe18ec"}[chunkId] + ".chunk.js";
};